import { onValue, ref, remove, update } from 'firebase/database';
import React, { useState, useEffect, useRef } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router';
import { Link } from 'react-router-dom';

import {
  getStudentView,
  subjectsObj,
  deleteFilesStudentHomeworks,
  setStudentHomeworkTeacherChacked,
  getHomeworkContentStudent,
} from '../../Common/Database';
import { database } from '../../Common/Firebase';
import Loader from '../../Components/Loader';
import NoItems from '../../Components/NoItems';
import { getUserType } from '../../redux/slices/userSlice';

import './style.scss';
import { PopupHomework } from '../../Components/PopupHomework/PopupHomework';
import Tooltipe from '../../Components/Tooltipe';
import { throwErrorRollbar } from '../../index';
import { setClassroomName } from '../../redux/slices/nameClassroomSlice';

const arrItems = ['homeworks', 'materials', 'passedExams', 'exums'];

const ClassRoomList = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const userTypeSelector = useSelector(getUserType);

  const [homeworksContent, setHomeworksContent] = useState({});
  const [classroomList, setClassroomList] = useState([]);
  const [classroomObj, setClassroomObj] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [popupRemove, setPopupRemove] = useState(false);
  const [popupRemoveName, setPopupRemoveName] = useState('');
  const [ativeItem, setAtiveItem] = useState(0);
  const [openModalAnswer, setOpenModalAnswer] = useState(false);
  const [modalAnswer, setModalAnswer] = useState('');
  const [openPopupHomework, setOpenPopupHomework] = useState(false);
  const [popupHomeworkObj, setPopupHomeworkObj] = useState({});
  const [userType, setUserType] = useState(userTypeSelector);

  const admins = userType === 'NewAdmin' || userType === 'Admin' || userType === 'Superadmin';

  function usePrevious(value) {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    });

    return ref.current;
  }

  const prevClassroomList = usePrevious(classroomList);

  const setResponsItems = resp => {
    switch (ativeItem) {
      case 0:
        let setHomework = Object.values(resp.homeworks ? resp.homeworks : {});
        let filterHomework = setHomework.filter(item => item.subject === params.name);
        setClassroomList(filterHomework);
        break;
      case 1:
        let setMaterial = Object.values(resp.materials ? resp.materials : {});
        console.log('resp.materials: ', resp.materials);
        let filterMaterial = setMaterial.filter(
          item => subjectsObj[item.subject] === params.name && !('chapter' in item),
        );
        setClassroomList(filterMaterial);
        break;
      case 2:
        let setMaterialSecond = Object.values(resp.materials || {});
        let filterMaterialSecond = setMaterialSecond.filter(item => {
          // Проверяем наличие ключа chapter и что он является массивом
          if (Array.isArray(item.chapter)) {
            // Проверяем, что все элементы в chapter соответствуют условию
            return item.chapter.every(chapterItem => {
              // Проверяем, что у chapterItem есть ключ points и что он является массивом
              if (Array.isArray(chapterItem.points)) {
                // Проверяем, что у всех элементов в points есть ключ itemCompleted со значением true
                return chapterItem.points.every(pointItem => pointItem.itemComplited === true);
              }
              return false;
            });
          }
          return false;
        });
        console.log('filterMaterialSecond', filterMaterialSecond);
        setClassroomList(filterMaterialSecond);
        break;
      case 3:
        let setMaterialThree = Object.values(resp.materials ? resp.materials : {});
        let filterMaterialThree = setMaterialThree.filter(
          item => subjectsObj[item.subject] === params.name && 'chapter' in item,
        );
        console.log('filterMaterialSecond', filterMaterialThree);
        setClassroomList(filterMaterialThree);
        break;
    }
    setIsLoading(false);
  };

  const [fio, setFio] = useState({});

  useEffect(() => {
    console.log('classroomList: ', classroomList);
    const dbRef = ref(database, `Students/${params.id}`);

    const unsubscribe = onValue(dbRef, snapshot => {
      const obj = snapshot.val();
      setFio({ lastName: obj.lastName, firstName: obj.firstName });
      setClassroomObj(obj);
    });

    // Функция очистки, которая будет вызвана при размонтировании компонента
    return () => {
      unsubscribe();
    };
  }, [params]);

  const fetchClassroomList = async () => {
    await getStudentView(params.id)
      .then(response => {
        const resp = response.val();
        try {
          setClassroomObj(resp);
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
        }
      })
      .catch(error => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchClassroomList();
    setUserType(userTypeSelector);
  }, [userTypeSelector, userType]);

  const getHomeworkFunc = async params => {
    try {
      const objContentHM = await getHomeworkContentStudent(params);
      console.log('objContentHM', objContentHM);
      return objContentHM;
    } catch (error) {
      console.error('An error occurred while getting homework content:', error);
      error.name = 'An error occurred while getting homework content:';
      throwErrorRollbar(error);
      return {};
      // здесь вы можете обработать ошибку, например, установить состояние ошибки или выбросить исключение дальше
      // throw error; // если вы хотите пробросить ошибку дальше
    }
  };

  useEffect(() => {
    async function fetchHomework() {
      const objContentHMNew = await getHomeworkFunc(params.name);
      setHomeworksContent(objContentHMNew); // Раскомментируйте это, если вам нужно обновить состояние
    }

    fetchHomework();
  }, []);

  const ocClosePopupHomework = () => {
    setOpenPopupHomework(false);
  };

  //TODO:
  // useEffect(() => {
  //   console.log('homeworksContent',homeworksContent);
  // }, [homeworksContent]);

  useEffect(() => {
    console.log('ativeItem: ', ativeItem);
    if (classroomObj.homeworks || classroomObj.materials) {
      setResponsItems(classroomObj);
    }
  }, [classroomObj, ativeItem]);

  useEffect(() => {
    classroomList.forEach((item, i) => {
      if (JSON.stringify(item.teacherCheckeds) !== JSON.stringify(prevClassroomList[i]?.teacherCheckeds)) {
        setStudentHomeworkTeacherChacked(params.id, params.name, item.id, item.teacherCheckeds);
      }
    });
  }, [classroomList, prevClassroomList]);

  const parseJson = data => {
    try {
      const parsedData = JSON.parse(data);
      // если да, просто возвращаем их
      console.log(parsedData);
      return parsedData;
    } catch {
      // если не удалось распарсить данные, возвращаем их в виде массива
      return data;
    }
  };

  // функция обработчика
  function handleTeacherCheckboxChange(event, id, keyName) {
    const isChecked = event.target.checked;

    setClassroomList(prevList => {
      return prevList.map(item => {
        if (item.id === id) {
          const teacherItem = item.teacherCheckeds ? parseJson(item.teacherCheckeds) : item.teacherCheckeds;
          console.log({ teacherItem });
          return {
            ...item,
            teacherCheckeds: teacherItem.map(checkedItem => {
              console.log(checkedItem);
              if (Object.keys(checkedItem)[0] === keyName) {
                return { [keyName]: isChecked };
              } else {
                return checkedItem;
              }
            }),
          };
        } else {
          return item;
        }
      });
    });
  }

  const columns1 = [
    {
      dataField: 'name',
      text: t('homework'),
      headerStyle: {
        // width: '100%',
      },
      classes: 'name-homework',
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('homework') },
    },
    {
      dataField: 'deadline',
      text: t('deadline'),
      disableClickEventBubbling: true,
      sort: true,
      sortFunc: (a, b, order, dataField) => {
        const dateA = new Date(parseInt(a.split('.')[2]), parseInt(a.split('.')[1]) - 1, parseInt(a.split('.')[0]));

        const dateB = new Date(parseInt(b.split('.')[2]), parseInt(b.split('.')[1]) - 1, parseInt(b.split('.')[0]));

        if (order === 'asc') {
          return dateA - dateB;
        } else {
          return dateB - dateA;
        }
      },
      attrs: { 'data-label': t('deadline') },
    },
    {
      dataField: 'completed',
      text: t('done'),
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('done') },
      formatter: (dataField, row) => {
        if (row.subItems) {
          const subArrayCheckeds = row.subArrayCheckeds || [];
          const subItemsCompleted = subArrayCheckeds.filter(item => item.completed);

          return (
            <div className="sub-inputs-checkboxs">
              {subArrayCheckeds.map((item, i) => (
                <div className="wrap-sub-input-checkbox">
                  <input
                    key={i}
                    type="checkbox"
                    checked={item}
                    id={String(dataField)}
                    className="checkbox check-homework"
                    readOnly
                  />
                  <span className="name-sub-input-checkbox" name={row.titles[i]} data-item="true">
                    {row.titles[i]}
                  </span>
                </div>
              ))}
            </div>
          );
        } else {
          return (
            <div>
              <input
                id={String(dataField)}
                type="checkbox"
                checked={dataField}
                className="checkbox check-homework"
                readOnly
              />
              <span className="name-sub-input-checkbox" name={row.name} data-item="false">
                {row.name}
              </span>
            </div>
          );
        }
      },
    },
    {
      dataField: 'teacherCheckeds',
      text: t('checked'),
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('checked') },
      formatter: (dataField, row) => {
        const teacherItem = row.teacherCheckeds ? parseJson(row.teacherCheckeds) : row.teacherCheckeds;
        if (teacherItem) {
          console.log(teacherItem);
          console.log(row.teacherCheckeds);
          return (
            <div className="sub-teacher-inputs-checkboxs">
              {teacherItem.map((item, i) => {
                const keyName = Object.keys(item)[0];
                return (
                  <div className="teacher-checked-input-checkbox" key={keyName + i}>
                    <label htmlFor={item[keyName]}>
                      <input
                        type="checkbox"
                        onChange={event => handleTeacherCheckboxChange(event, row.id, keyName)}
                        id={item[keyName]}
                        checked={item[keyName]}
                        className="checkbox"
                      />
                      <span className="teacher-checked-checkbox">{t(keyName)}</span>
                    </label>
                  </div>
                );
              })}
            </div>
          );
        }
      },
    },

    {
      dataField: 'id',
      text: t('actions'),
      attrs: { 'data-label': t('actions') },
      formatter: (dataField, row) => (
        <div className="btn-wrap">
          {row.hasOwnProperty('studentPhotos') && Object.values(row.studentPhotos).length > 0 ? (
            <button className="btn btn-primary btn-small open-modal-studet-photos">{t('look')}</button>
          ) : null}
          <Tooltipe text="delete" icon="icon-delete" btnClass="delete-homework" id={String(dataField)} />
        </div>
      ),
    },
  ];

  const columns2 = [
    {
      dataField: 'name',
      text: t('material'),
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('material') },
    },
    {
      dataField: 'grade',
      text: t('class'),
      width: 130,
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('class') },
    },
    {
      dataField: 'subject',
      text: t('subject'),
      width: 130,
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('subject') },
      formatter: cell => {
        return t(cell);
      },
    },
    {
      dataField: 'theme',
      text: t('theme'),
      flex: 1,
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('theme') },
    },
    {
      dataField: 'id',
      text: t('actions'),
      attrs: { 'data-label': t('actions') },
      formatter: dataField => (
        <div className="btn-wrap">
          <Tooltipe text="delete" icon="icon-delete" btnClass="materials" id={String(dataField)} />
        </div>
      ),
    },
  ];

  const columns3 = [
    {
      dataField: 'name',
      text: t('exam'),
      headerStyle: {
        // width: '100%',
      },
      disableClickEventBubbling: true,
    },
    {
      dataField: 'grade',
      text: t('class'),
      width: 130,
      disableClickEventBubbling: true,
    },
    {
      dataField: 'subject',
      text: t('subject'),
      width: 130,
      disableClickEventBubbling: true,
    },
    // {
    //   dataField: 'theme',
    //   text: t('theme'),
    //   flex: 1,
    //   disableClickEventBubbling: true,
    // },
  ];

  const columns4 = [
    {
      dataField: 'name',
      text: t('nameCourse'),
      headerStyle: {
        // width: '100%',
      },
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('nameCourse') },
    },
    {
      dataField: 'purpose',
      text: t('purpose'),
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('purpose') },
    },
    {
      dataField: 'deadline',
      text: t('deadline'),
      disableClickEventBubbling: true,
      sort: true,
      sortFunc: (a, b, order, dataField) => {
        const dateA = new Date(parseInt(a.split('.')[2]), parseInt(a.split('.')[1]) - 1, parseInt(a.split('.')[0]));

        const dateB = new Date(parseInt(b.split('.')[2]), parseInt(b.split('.')[1]) - 1, parseInt(b.split('.')[0]));

        if (order === 'asc') {
          return dateA - dateB;
        } else {
          return dateB - dateA;
        }
      },
      attrs: { 'data-label': t('deadline') },
    },
    {
      dataField: 'grade',
      text: t('class'),
      width: 130,
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('class') },
    },
    {
      dataField: 'subject',
      text: t('subject'),
      width: 130,
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('subject') },
      formatter: cell => {
        return t(cell);
      },
    },
    // {
    //   dataField: 'theme',
    //   text: t('theme'),
    //   headerStyle: {
    //     width: '50%',
    //   },
    //   disableClickEventBubbling: true,
    //   attrs: { 'data-label': t('theme') },
    // },
    {
      dataField: 'id',
      text: t('actions'),
      attrs: { 'data-label': t('actions') },
      formatter: dataField => (
        <div className="btn-wrap">
          <button id={String(dataField)} className="btn btn-primary btn-small go-to-exem">
            {t('transition-in')}
          </button>

          <Tooltipe text="delete" icon="icon-delete" btnClass="delete-exem" id={String(dataField)} />
        </div>
      ),
    },
  ];

  const pageSize = 10;

  const pagination = paginationFactory({
    sizePerPage: pageSize,
    hideSizePerPage: true,
  });

  const rowEvents = {
    onClick: async (e, row) => {
      console.log(row);

      if (e.target.className === 'name-homework') {
        const objInfoUserHM = {
          user: params.id,
          item: row.name,
          name: row.name,
        };
        dispatch(setClassroomName(objInfoUserHM));
        navigate(`/student-homework-list/${row.subject}/${params.id}`);
      }

      if (e.target.tagName !== 'BUTTON' && ativeItem === 1) {
        navigate('/materialView', { state: row });
      }

      // if (e.target.tagName !== 'BUTTON' && ativeItem === 2) {
      //   navigate('/examView', { state: row, search: location.state });
      // }

      if (e.target.className === 'btn btn-primary btn-small go-to-exem' && (ativeItem === 2 || ativeItem === 3)) {
        console.log('row: ', row);
        if (admins) {
          navigate(`/checklist-view/${row.id}`, {
            state: { ...row, studentId: params.id },
          });
        } else {
          navigate(`/checklist-teacher/${row.id}`, {
            state: {
              ...row,
              studentId: params.id,
              firstName: fio.firstName,
              lastName: fio.lastName,
            },
          });
        }
      }

      if (e.target.className === 'btn btn-primary more btn-active') {
        try {
          const subjectName = row.name;
          await update(ref(database, `Students/${params.id}/subjects/${subjectName}`), {
            activeSub: !row.activeSub,
            name: row.name,
          });
          setSubjectList();
          setAddSubject(prev => !prev);
        } catch (error) {
          console.log(error);
          error.name = 'Error fetching contact ' + error.name;
          throwErrorRollbar(error);
        }
      }
      if (e.target.className === 'btn btn-icon delete-homework') {
        try {
          const homeworkName = row.name;
          localStorage.setItem('rowName', homeworkName);
          setModalAnswer(row);
          setPopupRemoveName('want to delete homework for student');
          setPopupRemove(true);
        } catch (error) {
          console.log(error);
          error.name = 'Error fetching contact ' + error.name;
          throwErrorRollbar(error);
        }
      }

      if (e.target.className === 'name-sub-input-checkbox') {
        const homeworkId = row.id;
        const nameItem = e.target.getAttribute('name');

        setPopupHomeworkObj({});
        setOpenPopupHomework(false);

        setTimeout(() => {
          setPopupHomeworkObj({
            deadline: row.deadline,
            homeworkName: row.name,
            titels: row.titles,
            targetSubItem: nameItem,
            targetItem: {
              ops: JSON.parse(homeworksContent[homeworkId].content),
              id: row.id,
            },
          });
          setOpenPopupHomework(true);
        }, 10);
      }

      // if(e.target.className === 'btn btn-primary more btn-active btn-delete') {
      //   try {
      //     const materialsId = row.id;
      //     localStorage.setItem('rowName', materialsId);
      //     setPopupRemove(true);
      //   } catch (error) {
      //     console.log(error);
      //   }
      // }

      if (e.target.className === 'btn btn-icon materials') {
        try {
          const materialsId = row.id;
          localStorage.setItem('rowName', materialsId);
          setPopupRemoveName('want to delete subject for student');
          setPopupRemove(true);
        } catch (error) {
          console.log(error);
          error.name = 'Error fetching contact ' + error.name;
          throwErrorRollbar(error);
        }
      }

      if (e.target.className === 'btn btn-icon delete-exem') {
        try {
          const materialsId = row.id;
          localStorage.setItem('rowName', materialsId);
          setPopupRemoveName('want to delete exam for student');
          setPopupRemove(true);
        } catch (error) {
          console.log(error);
          error.name = 'Error fetching contact ' + error.name;
          throwErrorRollbar(error);
        }
      }

      if (e.target.className === 'btn btn-primary btn-small open-modal-studet-photos') {
        setOpenModalAnswer(true);
        setModalAnswer(row);
      }
    },
  };

  const moveNotebook = () => {
    navigate(`/notebook/${params.id}/${params.name}`);
  };

  const removeHomework = async () => {
    const removeItem = localStorage.getItem('rowName');
    switch (ativeItem) {
      case 0:
        await remove(ref(database, `Students/${params.id}/homeworks/${modalAnswer.id}`), {
          removeItem,
        });
        deleteFilesStudentHomeworks(params.id, modalAnswer.id);
        break;
      case 1:
        await remove(ref(database, `Students/${params.id}/materials/${removeItem}`), {
          removeItem,
        });
        break;
      case 2:
        await remove(ref(database, `Students/${params.id}/materials/${removeItem}`), {
          removeItem,
        });
        break;
      case 3:
        await remove(ref(database, `Students/${params.id}/materials/${removeItem}`), {
          removeItem,
        });
        break;
    }

    localStorage.removeItem('rowName');
    fetchClassroomList();
    setPopupRemove(false);
  };

  const notRemoveHomework = () => {
    localStorage.removeItem('rowName');
    setPopupRemove(false);
  };

  const onClickActiveItem = (e, i) => {
    e.preventDefault();
    setAtiveItem(i);
  };

  const FileRenderer = ({ url }) => {
    const [fileType, setFileType] = React.useState(null);
    const [error, setError] = React.useState(null);

    React.useEffect(() => {
      async function fetchAndSetFileType() {
        try {
          const type = await fetchFileContent(url);
          setFileType(type);
        } catch (err) {
          setError(err.message);
        }
      }

      fetchAndSetFileType();
    }, [url]);

    if (error) return <div>Error: {error}</div>;

    if (!fileType) return <div>Loading...</div>;

    if (fileType === 'image') {
      return <img src={url} alt="File" />;
    }

    if (fileType === 'word') {
      return (
        <iframe
          src={`https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`}
          style={{ width: '90%', height: '500px', border: 'none' }}
        ></iframe>
      );
    }

    return <div>Unsupported file type</div>;
  };

  const fetchFileContent = async url => {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const blob = await response.blob();
      const type = blob.type;

      if (type.startsWith('image/')) {
        return 'image';
      } else if (
        type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        type === 'application/msword'
      ) {
        return 'word';
      } else {
        return 'unknown';
      }
    } catch (error) {
      console.log('There was a problem with the fetch operation:', error.message);
      error.name = 'There was a problem with the fetch operation:';
      throwErrorRollbar(error);
    }
  };

  return (
    classroomList && (
      <>
        <div className="title-wrap">
          <h1>{`${t(params.name)}, ${fio.lastName} ${fio.firstName}`}</h1>
        </div>
        <div className="materials-page classroom-list-page container">
          <div className="classroom-list-row-top">
            <button className="btn more" onClick={moveNotebook}>
              {t('goNotebook')}
            </button>

            <ul className="classroom-list-navigate">
              {arrItems.map((item, i) => (
                <li key={i}>
                  <a href="#" className={i === ativeItem ? 'active' : ''} onClick={e => onClickActiveItem(e, i)}>
                    {t(item)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <hr />
          {isLoading ? (
            <Loader />
          ) : (
            <>
              {ativeItem === 0 &&
                (classroomList.length > 0 ? (
                  <ToolkitProvider
                    key={i18n.language}
                    keyField="content"
                    data={classroomList}
                    columns={columns1}
                    isLoading={isLoading}
                    noDataIndication={() => <NoItems titleNoItems={'noExam'} />}
                    loadingIndicator={<Loader />}
                  >
                    {props => (
                      <div className="materials-table">
                        <BootstrapTable
                          {...props.baseProps}
                          pagination={classroomList.length > pageSize ? pagination : null}
                          rowEvents={rowEvents}
                          defaultSorted={[{ dataField: 'deadline', order: 'asc' }]}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                ) : (
                  <NoItems titleNoItems={'noHomeworks'} />
                ))}
              {ativeItem === 1 &&
                (classroomList.length > 0 ? (
                  <ToolkitProvider
                    key={i18n.language}
                    keyField="content"
                    data={classroomList}
                    columns={columns2}
                    isLoading={isLoading}
                    noDataIndication={() => <NoItems titleNoItems={'noMaterials'} />}
                    loadingIndicator={<Loader />}
                  >
                    {props => (
                      <div className="materials-table">
                        <BootstrapTable
                          {...props.baseProps}
                          pagination={classroomList.length > pageSize ? pagination : null}
                          rowEvents={rowEvents}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                ) : (
                  <NoItems titleNoItems={'noMaterials'} />
                ))}
              {ativeItem === 2 &&
                (classroomList.length > 0 ? (
                  <ToolkitProvider
                    key={i18n.language}
                    keyField="content"
                    data={classroomList}
                    columns={columns4}
                    isLoading={isLoading}
                    noDataIndication={() => <NoItems titleNoItems={'noExam'} />}
                    loadingIndicator={<Loader />}
                  >
                    {props => (
                      <div className="materials-table done-exam">
                        <BootstrapTable
                          {...props.baseProps}
                          pagination={classroomList.length > pageSize ? pagination : null}
                          rowEvents={rowEvents}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                ) : (
                  <NoItems titleNoItems={'noExam'} />
                ))}

              {ativeItem === 3 &&
                (classroomList.length > 0 ? (
                  <ToolkitProvider
                    key={i18n.language}
                    keyField="content"
                    data={classroomList}
                    columns={columns4}
                    isLoading={isLoading}
                    noDataIndication={() => <NoItems titleNoItems={'noMaterials'} />}
                    loadingIndicator={<Loader />}
                  >
                    {props => (
                      <div className="materials-table exam">
                        <BootstrapTable
                          {...props.baseProps}
                          pagination={classroomList.length > pageSize ? pagination : null}
                          rowEvents={rowEvents}
                          defaultSorted={[
                            { dataField: 'deadline', order: 'asc' },
                            { dataField: 'time', order: 'asc' },
                          ]}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                ) : (
                  <NoItems titleNoItems={'noMaterials'} />
                ))}
            </>
          )}
          <div className={popupRemove ? 'popup-remove active' : 'popup-remove'}>
            <div className="popup-remove-content">
              <h3>{t(popupRemoveName)}</h3>

              <div className="btn-wrap">
                <button className="btn btn-primary more btn-active" onClick={() => removeHomework()}>
                  {t('yes')}
                </button>

                <button className="btn more btn-view" onClick={notRemoveHomework}>
                  {t('no')}
                </button>
              </div>
            </div>
          </div>

          {openPopupHomework && popupHomeworkObj && (
            <PopupHomework homeworkObj={popupHomeworkObj} closeHomework={setOpenPopupHomework} />
          )}

          {openModalAnswer && (
            <div className={openModalAnswer ? 'popup-answer-student active' : 'popup-answer-student'}>
              <div className="popup-answer-student-content">
                <button className="btn btn-icon" onClick={() => setOpenModalAnswer(false)}>
                  <span className="icon icon-plus"></span>
                </button>

                <h2>{t('Student Answers')}</h2>

                <div className="img-block">
                  {modalAnswer &&
                    Object.values(modalAnswer.studentPhotos)
                      .filter(elem => elem)
                      .map((item, i) => {
                        const hasNestedArray = Array.isArray(item[0]);

                        if (hasNestedArray) {
                          return Object.values(item).map((itemElem, ElemIndex) => {
                            console.log('modalAnswer', modalAnswer);
                            return (
                              <div key={ElemIndex} className="wrap-content-images">
                                <h3>{modalAnswer.titles[ElemIndex]}</h3>

                                <div className="col-images">
                                  {itemElem.map((itemImg, indexImg) => {
                                    return (
                                      <div className="wrap-img" key={ElemIndex + indexImg}>
                                        <FileRenderer url={itemImg} />
                                        {/* <img src={itemImg} alt="image" /> */}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          });
                        } else {
                          return (
                            <div key={i} className="wrap-content-images">
                              <h3>{modalAnswer.name}</h3>

                              <div className="col-images">
                                {Object.values(item).map((itemImg, indexImg) => {
                                  return (
                                    <div className="wrap-img" key={i + indexImg}>
                                      <FileRenderer url={itemImg} />
                                      {/* <img src={itemImg} alt="image" /> */}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        }
                      })}
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    )
  );
};

export default ClassRoomList;
